<!--
 * @Author: error: git config user.name & please set dead value or install git
 * @Date: 2024-05-28 16:08:52
 * @Description: 在此处清晰,简洁的说明本文件的作用
-->
<template>
  <div id="app" :class="[GET_IS_DARK && 'dark-model']">
    <!-- <el-button @click="load(8)">123</el-button> -->
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { debounce } from "@/utils/common";
export default {
  name: "App",
  components: {},
  computed: {
    is_loading() {
      return this.$store.getters.GET_LAYOUT_LOADING;
    },
    ...mapGetters(["GET_IS_DARK"]),
  },
  data() {
    return {
      timeout: undefined,
      testNum: 1,
    };
  },
  watch: {
    is_loading: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.timeout = setTimeout(() => {
            if (this.$store.getters.GET_LAYOUT_LOADING) {
              // location.reload();
              this.$store.commit("SET_LAYOUT_LOADING", false);
              this.$message.error(this.$t("request_timeout"));
            }
            clearTimeout(this.timeout);
          }, 10000);
        } else {
          clearTimeout(this.timeout);
        /*  */}
      },
    },
  },
  methods: {
    // load:debounce(function() {
    //     let args = arguments;
    //     this.add(...args);
    //   },
    //   1000
    // ),
    // add(val) {
    //   this.testNum ++
    //   console.log(val,this.testNum)
    // },
    selectPrinter(index, type) {
      if (type == 0) {
        let item = this.$store.getters.GET_LAN_PRINTER_LIST.find((item) => {
          return item.deviceId == index;
        });
        if (item) {
          this.$store.commit("SET_PRINTER_TYPE", "lan");

          this.$store.dispatch("SET_LAN_MQTT", item);

          this.$router.push("/workbench");
          return true;
        }
      } else {
        let item = this.$store.getters.GET_CLOUD_PRINTER_LIST.find((item) => {
          return item.id == index;
        });
        if (item) {
          this.$store.commit("SET_PRINTER_TYPE", "cloud");
          this.$router.push({
            path: "/workbench",
            query: { id: item.id, key: item.key },
          });
          return true;
        }
      }
      return false;
    },
  },
  mounted() {
    let vm = this;
    // 监听网络离线事件
    window.addEventListener("offline", function () {
      console.log("当前网络已离线");
      // 在这里执行离线时的逻辑
      vm.$store.commit("SET_ISONLINE", false);
    });

    // 监听网络在线事件
    window.addEventListener("online", function () {
      console.log("当前网络已恢复在线");
      // 在这里执行在线时的逻辑
      vm.$store.commit("SET_ISONLINE", true);
    });
    window.selectPrinter = this.selectPrinter.bind(this);
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  font-family: AlibabaPuHuiTi-3-55-Regular !important;
}
img {
  user-select: none;
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -ms-user-drag: none;
  user-drag: none;
}
#app {
  background: var(--workbench-base-color);
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  /* display: none; */
}
::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb {
  background-color: var(--webkit-line);
  border-radius: 3px;
}
.btn {
  background: var(--dialog-background-color);
  line-height: 18px;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid var(--VI-color);
  text-align: center;

  font-weight: normal;
  font-size: 14px;
  color: var(--VI-color);
  box-sizing: border-box;
  cursor: pointer;
  padding: 2px 25px;
}
.priBtn {
  line-height: 20px;
  background: var(--VI-color);
  border-radius: 6px 6px 6px 6px;
  text-align: center;

  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  box-sizing: border-box;
  cursor: pointer;
  padding: 2px 25px;
}
.busy {
  padding: 1px 4px;
  box-sizing: border-box;
  background: #fffbe6;
  border-radius: 4px 4px 4px 4px;
  height: 19px;

  font-weight: normal;
  font-size: 12px;
  color: #faad14;
  line-height: 17px;
}
.free {
  padding: 1px 4px;
  box-sizing: border-box;
  background: #dbebd1;
  border-radius: 4px 4px 4px 4px;
  height: 19px;

  font-weight: normal;
  font-size: 12px;
  color: #389e0d;
  line-height: 17px;
}
.offline {
  padding: 1px 4px;
  box-sizing: border-box;
  background: #e1e3e6;
  border-radius: 4px 4px 4px 4px;
  height: 19px;

  font-weight: normal;
  font-size: 12px;
  color: #595959;
  line-height: 17px;
}

.el-message-box--center {
  padding-bottom: 15px !important;
}
.el-message-box--center .el-message-box__header {
  padding-top: 15px !important;
}
</style>
